module.exports = __webpack_public_path__ + "img/LogoStattus4PositivoVerde.d0aa1c02.png";